import React, { useState } from "react";
import { MdKeyboardArrowUp, MdKeyboardArrowDown } from 'react-icons/md';

export const DisplayServiceCard = ({ data, isArabic }) => {
    const [enableCard, setEnableCard] = useState(false);
    const [openCardID, setOpenCardID] = useState('');

    return(
        <div className="mb-6" style={{border: '1px solid #121180', borderRadius: 4, overflow: 'hidden'}}>
            <div className={"d-flex justify-content-between align-items-center bg-white mb-0 p-4 px-6 cursor-pointer " + (isArabic ? "flex-row-reverse" : "flex-row")} onClick={() => setEnableCard(!enableCard)}>
                <h6 style={{fontSize: '14px', color: '#121180'}} className="m-0">{isArabic ? 'بطاقة الخدمة' : 'Service Card'}</h6>
                {enableCard ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
            </div>
            {enableCard && <div className="accordion accordion-light accordion-toggle-arrow">
                {data && data.map(({title, description, arabicTitle, arabicDescription}, index) => <div className="card px-6" key={index}>
                    <div className="card-header" id="headingOne2">
                        <div className={"d-flex justify-content-between card-title " + ((openCardID === index) ? "" : "collapsed ") + (isArabic ? "flex-row-reverse" : "flex-row")} onClick={() => setOpenCardID((openCardID === index) ? '' : index)}>
                            <span style={{fontSize: 13, color: '#121180', webkitUserSelect: 'none', webkitTouchCallout: 'none', mozUserSelect: 'none', msUserSelect: 'none', userSelect: 'none'}}>{isArabic ? arabicTitle : title}</span>
                            <div className="d-flex">
                                {(openCardID === index) ? <MdKeyboardArrowUp /> : <MdKeyboardArrowDown />}
                            </div>
                        </div>
                    </div>
                    <div className={"collapse cursor-default " + ((openCardID === index) ? "show" : "")} style={{webkitUserSelect: 'none', webkitTouchCallout: 'none', mozUserSelect: 'none', msUserSelect: 'none', userSelect: 'none'}}>
                        <div className={"card-body " + (isArabic ? "text-right" : "text-left")} dir={isArabic ? 'rtl' : 'ltr'} dangerouslySetInnerHTML={{__html: (isArabic ? arabicDescription : description)}} />
                    </div>
                </div>)}
            </div>}
        </div>
    );
};